import "./pages/show/showHandoffBootstrap";
import "./config";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { registerRetirementWorker } from "./registerRetirementWorker";
import { Capacitor } from "@capacitor/core";
import { initTelemetry } from "@um/ui";
import {
  applyDevSafeZoneCssVars,
  isDevSafeZonePreviewEnabled,
  readDevSafeZoneInsetPx,
  readDevSafeZonePresetMode,
} from "./dev/safeZonePreviewEnv";

/**
 * Web dev only: class + initial insets before React mounts. Insets are then owned by
 * DevSafeZonePreviewControls (preset + optional slider). Opt out: VITE_DEV_SAFE_ZONE=0
 */
function applyDevSafeZonePreview() {
  // Guest stages fill a real screen. Phone preview guides and artificial
  // insets must not be baked into the renderer embedded by um.show.
  if (
    /^\/show\/(?:view|screen|join|pair|preview|edit)(?:\/|$)/.test(
      window.location.pathname
    )
  )
    return;
  if (!isDevSafeZonePreviewEnabled()) return;

  const el = document.documentElement;
  el.classList.add("dev-safe-zone-preview");
  applyDevSafeZoneCssVars(
    readDevSafeZonePresetMode(),
    readDevSafeZoneInsetPx()
  );
}

const startupDiagnostic = (
  window as Window & {
    __umStartupDiagnostic?: (kind: string, message: string) => void;
  }
).__umStartupDiagnostic;
startupDiagnostic?.("APP", "Module imports loaded; starting application");

applyDevSafeZonePreview();

// Retire the former app-wide PWA only on web; offline downloads register separately.
if (!Capacitor.isNativePlatform()) {
  registerRetirementWorker();
}

initTelemetry();

startupDiagnostic?.("REACT", "Requesting first render");

ReactDOM.createRoot(document.getElementById("root")!).render(
  // Strict mode is disabled for now because it makes show playback animation very slow.  It is unclear if this is useful when AI is doing most of the work. But it makes it difficult to catch changes that actaully slow down the animation.
  //<React.StrictMode>
  <App />
  //</React.StrictMode>
);
